import { I18nComponente } from "@/types/gerais"

export const ListarEstatisticasi18n: I18nComponente = {
  "pt-BR": {
    ocorreuUmErroAoBuscarAsAtividadesRealizadas: "Ocorreu um erro ao buscar as atividades realizadas.",
    ocorreuUmErroAoBuscarOsEventosPlanejados: "Ocorreu um erro ao buscar os eventos planejados",
  },
  "es-CO": {
    ocorreuUmErroAoBuscarAsAtividadesRealizadas: "Ocurrió un error al buscar las actividades realizadas.",
    ocorreuUmErroAoBuscarOsEventosPlanejados: "Ocurrió un error al buscar los eventos planeados",
  },
}
